/*
 * @Author: bbqin
 * @Date: 2023-02-22 15:24:05
 * @LastEditTime: 2023-09-07 15:42:58
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\components\manager\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from "react";
import { Tooltip, Dropdown, Menu } from '@platform/base';
import classNames from 'classnames';
import { isBoolean, isFunction } from "../../libs/utils";
// import Dnd from '../../libs/dnd';
import BeautifulDnd from '../../libs/beautiful-dnd';

const { Item: MenuItem } = Menu;

class ManagerOverlay extends Component {
    constructor(props) {
        super(props);
        this.state = { visible: false };
    }

    getWallets = () => {
        const { store } = this.props;
        const activeKey = store.getContainerActiveTab();
        let hasUserVisible = true;

        const wallets = store.getCardWallets(activeKey, props => {
            const { moduleId, isCustom } = props;
            if (isCustom) {
                return false;
            }
            const cards = store.getCards(activeKey, moduleId, cardProps => cardProps.visible);
            const { visible, originVisible, userVisible } = store.getCardWalletProps(moduleId);
            // 有任何一个用户级缓存
            hasUserVisible = hasUserVisible && isBoolean(userVisible);
            // return !!cards.length;
            // 全量
            return true;
        }, false);
        return { hasUserVisible, wallets };
    }

    handleVisibleChange = (visible, moduleId) => {
        const { store, disabledVisibleCache = {} } = this.props;
        const { onVisibleChange } = store.getCardWalletProps(moduleId);
        // const activeKey = store.getContainerActiveTab();
        const { wallets, hasUserVisible } = this.getWallets();
        // 某些卡片组不走缓存
        const activeKey = store.getContainerActiveTab();
        const currentTabDisabledVisibleCache = disabledVisibleCache[activeKey] || {};
        if (currentTabDisabledVisibleCache[moduleId]) {
            return;
        }
        if (!hasUserVisible) {
            wallets.forEach(wallet => {
                const { props = {} } = wallet;
                const { moduleId: currentModuleId } = props;
                const { visible: currentVisible, userVisible, originVisible } = store.getCardWalletProps(currentModuleId);
                // 禁用项
                if (currentModuleId !== moduleId && !currentTabDisabledVisibleCache[currentModuleId]) {
                    // const finalVisible = isBoolean(userVisible) ? userVisible : originVisible;
                    const finalVisible = isBoolean(userVisible) ? userVisible : currentVisible;
                    // 更新属性
                    store.setCardWalletProps(currentModuleId, 'visible', finalVisible, false, {
                        callback: () => { },
                        affectUserVisible: true,
                    });
                }
            });

            // 更新属性
            store.setCardWalletProps(moduleId, 'visible', !visible, true, {
                callback: () => {
                    // 缓存状态
                    store.setCacheMeta();
                    isFunction(onVisibleChange) && onVisibleChange(!visible, moduleId);
                },
                affectUserVisible: true,
            });

        } else {
            // 更新属性
            store.setCardWalletProps(moduleId, 'visible', !visible, true, {
                callback: () => {
                    // 缓存状态
                    store.setCacheMeta();

                    isFunction(onVisibleChange) && onVisibleChange(!visible, moduleId);
                },
                affectUserVisible: true,
            });
        }
    }

    // 拖拽结束
    onDragEnd = (finalData = [], dragItem) => {
        let { id, store } = this.props;
        const activeKey = store.getContainerActiveTab();
        const tabId = store.getStore(['idRelation', 'tabs', 'moduleId', activeKey]);
        if (tabId) {
            const wallets = store.getStore(['walletLists', tabId]) || [];
            const { $id: current$id } = dragItem;
            let current = null;
            let position = {
                prev: null,
                next: null,
            };

            // 获取数据位置
            finalData.forEach((wallet, index) => {
                const { $id } = wallet;
                if ($id === current$id) {
                    position.prev = (finalData[index - 1] || {}).$id;
                    position.next = (finalData[index + 1] || {}).$id;
                }
            });

            const nextData = [];
            // 取出数据
            wallets.forEach(wallet => {
                const { $id } = wallet;
                if ($id === current$id) {
                    current = wallet;
                }
            });

            // 和隐藏数据一起排序数据
            let isPush = false;
            wallets.forEach(wallet => {
                const { $id } = wallet;
                if ($id !== current$id) {
                    if (position?.prev === $id && !isPush) {
                        nextData.push(wallet);
                        nextData.push(current);
                        isPush = true;
                    } else if (position?.next === $id && !isPush) {
                        nextData.push(current);
                        nextData.push(wallet);
                        isPush = true;
                    } else {
                        nextData.push(wallet);
                    }
                }
            });

            // 只有一条显示  并且拖拽了一下
            if (current && !position.next && !position.prev) {
                nextData.push(current);
            }

            store.setStore(['walletLists', tabId], nextData, false);
            // 缓存状态
            store.setCacheMeta();

            store.forceUpdate();
        }

    }

    getListItem(item, index, params = {}) {
        const { store, prefixCls, disabledVisibleCache = {} } = this.props;

        const { $id, props = {}, label } = item;
        const { moduleId } = props;

        const { visible, originVisible, title, _langText, userVisible } = store.getCardWalletProps(moduleId);

        const key = moduleId || $id || index;
        const content = _langText || title || label;

        // const finalVisible = isBoolean(userVisible) ? userVisible : originVisible;
        const finalVisible = isBoolean(userVisible) ? userVisible : visible;

        // 某些卡片组不走缓存
        const activeKey = store.getContainerActiveTab();
        const currentTabDisabledVisibleCache = disabledVisibleCache[activeKey] || {};
        const disabledVisibleCacheCls = currentTabDisabledVisibleCache[moduleId] ? prefixCls + '-sort-menu-item-visible-disabled' : '';

        const itemDom = <div key={key} className={`${prefixCls}-sort-menu-item ${finalVisible ? '' : prefixCls + '-sort-menu-item-hidden'} ${disabledVisibleCacheCls}`}>
            <i className='iconfont icon-tuozhuai1' />
            <div className={`${prefixCls}-sort-menu-item-content`} title={content}>{content}</div>
            <div className={`${prefixCls}-sort-menu-item-icon`} onClick={this.handleVisibleChange.bind(this, finalVisible, moduleId)}>
                {finalVisible ? <i className='iconfont icon-icon-xianshi2' /> : <i className='iconfont icon-icon-yincang2' />}
            </div>
        </div>;

        return params.connectDragSource ? params.connectDragSource(itemDom) : itemDom;
    }

    render() {
        const { store, showSortIcon, prefixCls, draggable, id } = this.props;

        const activeKey = store.getContainerActiveTab();
        if (!showSortIcon || !activeKey) {
            return null;
        }

        // 包含虚拟数据, 但是如果子项都隐藏了 则不显示在这里
        const { wallets } = this.getWallets();

        // 显示内容
        let walletsDom = null;

        const langJson = store.getStore('langJson');

        if (!wallets.length) {
            walletsDom = <div className={`${prefixCls}-sort-menu-empty`}>
                <div className={`${prefixCls}-sort-menu-empty-content`}>
                    <i className={`${prefixCls}-sort-menu-empty-img`}></i>
                    <span>{langJson['container-empty-content']}</span>
                </div>
            </div>;
        } else {
            if (draggable && wallets.length > 1) {
                walletsDom = <BeautifulDnd
                    droppableId={`${id}_beautiful_dnd_id`}
                    items={wallets}
                    onDragEnd={this.onDragEnd}
                    renderItem={this.getListItem.bind(this)}
                    // dragResponse={true}
                />;
            } else {
                walletsDom = wallets.map(this.getListItem.bind(this));
            }
        }
        const dom = <Dropdown
            // trigger={['click', 'hover']}
            trigger={['click']}
            // showAction
            // hideAction={['mouseLeave', 'click']}
            // overlay={renderMenu.call(this, list, undefined, tabindex)}
            placement="bottomRight"
            overlay={(
                <div
                    className={`${prefixCls}-sort-overlay`}
                    onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                >
                    <div
                        className={`${prefixCls}-sort-menu`}
                    >
                        {walletsDom}
                    </div>
                </div>

            )}
            animation="slide-up"
            overlayClassName={classNames(`${prefixCls}-sort-dropdown-overlay`)}
            // getPopupContainer={() => {
            //     return document.body;
            // }}
            visible={this.state.visible}
            onVisibleChange={visible => {
                this.setState({ visible });
            }}
        >
            <i title={langJson['card-icon-component-manage']} className='iconfont icon-tianjiazhibiao' />
        </Dropdown>;

        return wallets.length ? dom : null;
    }

}

export default ManagerOverlay;